import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {

    Card,
    Result,
    Button

} from "antd";

const AgreementCard = ({

                           agreement,

                           onProceedPayment

                       }) => {

    const { symbol } = useCurrency();

    return (

        <Card

            style={{

                borderRadius:12,

                marginBottom:18

            }}

        >

            <Result

                status="success"

                title="Accord trouvé"

                subTitle={

                    `Montant : ${agreement.totalAmount} ${symbol(agreement.currency)}`

                }

                extra={[

                    <Button

                        type="primary"

                        key="pay"

                        onClick={onProceedPayment}

                    >

                        Procéder au paiement

                    </Button>

                ]}

            />

        </Card>

    );

};

export default AgreementCard;